module.exports = __webpack_public_path__ + "static/img/itmo-ru.d448726.png";